import { UserContext } from "Contexts/UserContext/UserContext";
import useNetwork from "Hooks/useNetwork";
import CookieReader from "Utilities/CookieUtilties/CookieReader";
import React, { useContext, useState, useEffect, useReducer } from "react";
import Script from "next/script";
import { TrackingContext } from "Contexts/TrackingContext/TrackingContext";
import LogRocket from "logrocket";
import useGlobalPrivacyControl from "Hooks/useGlobalPrivacyControl";
import { StorageAccessor } from "../../../Utilities/LocalStorageUtility/LocalStorageUtility";
import { isInApp } from "Hooks/useAppInstall/AppUtilities"

export default function Segment() {
  const { context: userContext } = useContext(UserContext);
  const { ga4SessionData, segmentReady, setSegmentReady } = useContext(TrackingContext);
  const [segmentApiKey, setSegmentApiKey] = useState()
  const { isGpcEnabled } = useGlobalPrivacyControl();


  const segmentDoneHandler = (e) => {
    if (typeof analytics === "undefined") console.error("Segment is not ready")
    setSegmentReady()
  };

  useEffect(() => {
    if (segmentReady) {
      const segmentTrack = window.analytics.track.bind(window.analytics);
      window.analytics.track = (...args) => {
        try {
          LogRocket.track(...args);
        } catch (e) {
          console.error(e);
        }
        try {
          segmentTrack(...args);
        } catch (e) {
          console.error(e);
        }
      };
    }
  }, [segmentReady])

  useEffect(() => {
    window.addEventListener("segmentLoaded", segmentDoneHandler);

    return () => {
      window.removeEventListener("segmentLoaded", segmentDoneHandler);
    };
  }, []);

  //const [networkData, setNetworkData] = useState({})

  useNetwork(
    (data) => {
      //the buy route is client side rendered so we don't want to fire like this.
      //segment middleware in tng react is firing its own page views
      if (segmentReady) {
        if (!window.location.href.includes("/buy")) {
          analytics.page({
            speed: `${data.speed}`,
            network: `${data.network}`,
            cpu: `${data.cpu}`,
            memory: `${data.memory}`,
            dataSaver: `${data.dataSaver}`,
          });
        }
      }
    },
    [segmentReady]
  );

  useEffect(() => {
    const host = window.location.hostname.toLowerCase();

    switch (host) {
      case "www.speedwaymotors.com":
        setSegmentApiKey("Kqqz7XsVdnN81nBHti25sIeLESudJDEh");
        break;
      case "staging.speedway2.com":
      case "qa.speedway2.com":
      default:
        setSegmentApiKey("6g5OCMzAvN6UebUc9rEXJSSt0f010JFB");
        break;
    }
  }, []);

  const [renderSegmentScript, setRenderSegmentScript] = useState(false);
  const campaignRegex = /utm_campaign=campaign_(\d+)/; // regex for matching Iterable url campaign ids

  useEffect(() => {
    // we need to wait until the user context has been updated with data (hydrated)
    // before allowing the script to render

    const shouldRender = !isGpcEnabled && userContext && userContext.hydrated && !userContext.isBot() && !userContext.isEmployee();
    console.info('shouldRenderLogObject', {'!isGpcEnabled': !isGpcEnabled, 
      'userContext': userContext, 
      'userContext.hydrated': userContext?.hydrated, 
      '!userContext.isBot()': !userContext?.isBot(), 
      '!userContext.isEmployee()': userContext?.isEmployee ? !userContext?.isEmployee() : 'isEmployeeCouldNotBeInvokedDueToNull'
    })
    if (shouldRender) {
      setRenderSegmentScript(true);
      if (window) {
        let currentUrl = window.location.href;
        if (currentUrl.includes("utm_source=Iterable")) {
          // set the expiration to 14 days in the future
          var datePlus14Days = new Date(Date.now());
          datePlus14Days.setDate(datePlus14Days.getDate() + 14);
          let datePlus14DaysString = datePlus14Days.toUTCString();

          // read in already set cookie (if any)
          let templateId = CookieReader("iterableTemplateId");
          let messageId = CookieReader("iterableMessageId");
          let campaignId = CookieReader("iterableEmailCampaignId");

          // check for a (new) campaign Id on the url, and use that if present
          let urlCampaignMatch = currentUrl.match(campaignRegex);
          let urlCampaignId =
            urlCampaignMatch == null ? "" : urlCampaignMatch[1];
          if (urlCampaignId != "") {
            campaignId = currentUrl.match(campaignRegex)[1];
          }

          let host = document.location.host.replace("www.", "");
          document.cookie = `iterableTemplateId=${templateId}; path=/; domain=${host}; expires=${datePlus14DaysString};`;
          document.cookie = `iterableMessageId=${messageId}; path=/; domain=${host}; expires=${datePlus14DaysString};`;
          document.cookie = `iterableEmailCampaignId=${campaignId}; path=/; domain=${host}; expires=${datePlus14DaysString};`;
        }
      }
    }
  }, [userContext?.hydrated, ga4SessionData, isGpcEnabled]);

  console.log('Segment boolean', !renderSegmentScript || !ga4SessionData || !segmentApiKey)
  console.info('segmentBooleanLogObject', {'!renderSegmentScript': !renderSegmentScript, 
    '!ga4SessionData': !ga4SessionData, 
    '!segmentApiKey': !segmentApiKey
  })
  if (!renderSegmentScript || !ga4SessionData || !segmentApiKey) {
    return false;
  }
  const isApp = isInApp();
  let grinJson = '{}'
  let tikTokJson = '{}'
  try {
    grinJson = JSON.stringify(StorageAccessor.localStorage.getObj("grin_cache"));
    tikTokJson = JSON.stringify(StorageAccessor.localStorage.getObj("tiktok_cache"));
  } catch (e) {
    console.error('failed to serialize social media data')
  }

  const segmentScript = `   
    if('${segmentApiKey}' === '')
    {
        console.error('No Segment API key was loaded')
    } 
    else{        
        var isBot = false
        if (navigator && navigator.userAgent) {
            var userAgent = navigator.userAgent.toLowerCase()
            var botList = ["GoogleBot", "facebot", "DuckDuckBot", "Baiduspider", "YandexBot", "Bingbot", "Slurp", "AboutUsBot", "Adsbot", "AlphaBot", "ArchiveBot", "AspiegelBot", "AwarioSmartBot", "BLEXBot", "BingPreview", "BingPreview 1.0", "Cliqzbot", "Cocolyzebot", "Discordbot", "DomCopBot", "DomainStatsBot", "DuckDuckGo", "Exabot", "FullStoryBot", "IndeedBot", "KenshooBot", "KomodiaBot", "LinkedInBot", "LinkisBot", "LivelapBot", "MAZBot", "Mail.RU_Bot", "MauiBot", "MojeekBot", "NetpeakCheckerBot", "OnalyticaBot", "PREMSGO", "PaperLiBot", "PubMatic", "Quora-Bot", "RedirectBot", "ResearchBot", "SEMrushBot", "ScraperBot", "SemanticScholarBot", "SeobilityBot", "SerendeputyBot", "SeznamBot", "SurdotlyBot", "TelegramBot", "TurnitinBot", "TweetmemeBot", "Twitterbot", "WordChampBot", "Yandex", "YelpBot", "ZoomBot", "ZoominfoBot", "adsbot-google", "ahrefs.com", "aiHitBot", "apis-google", "applebot", "archive.org_bot", "bingpreview", "bitlybot", "bot@linkfluence", "caliperbot", "chimebot", "cincrawdata", "coccocbot", "deepcrawl", "dotbot", "duckduckbot", "facebookexternalhit/1.1", "google-read", "istellabot", "linguee.com", "mediapartners-google", "mj12bot", "msnbot", "niocBot", "petalbot", "pinterest.com/bot", "rogerbot", "seewithkids.com", "semrush.com", "seotoolset", "serpstatbot", "seznambot", "slack.com", "smtbot", "superpagesbot", "xforce-security", "yahoo ad monitoring", "yahoo link preview", "yahoocachesystem"]
            for (var i = 0; i < botList.length; i++) {
                var value = userAgent.indexOf(botList[i].toLowerCase())
                if (value >= 0) {
                    isBot = true
                }
            }
        }
        !function () {
                var analytics = window.analytics = window.analytics || []; if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice."); else {
                    analytics.invoked = !0; analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"]; analytics.factory = function (e) { return function () { var t = Array.prototype.slice.call(arguments); t.unshift(e); analytics.push(t); return analytics } }; for (var e = 0; e < analytics.methods.length; e++) { var key = analytics.methods[e]; analytics[key] = analytics.factory(key) } analytics.load = function (key, e) {
                        var t = document.createElement("script"); t.type = "text/javascript"; t.async = !0; t.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js"; var n = document.getElementsByTagName("script")[0];
                        // we need this bot check to help us reduce calls to segment. If we update the segment script make sure we add this!!!!!!
                        if (!isBot) {
                            n.parentNode.insertBefore(t, n);
                        }
                        analytics._loadOptions = e
                    }; 
                    analytics._writeKey = '${segmentApiKey}'; analytics.SNIPPET_VERSION = "4.13.2";
                    const segmentOrderSourceMiddleware = function(middlewareOptions) {
                        const payload = middlewareOptions.payload;
                        const next = middlewareOptions.next;
                        payload.obj.anonymousId = '${userContext.userGuid}'
                        payload.obj.userVin = '${userContext.userVin()}'
                        payload.obj.isPWA = '${isApp}'
                        try {
                          payload.obj.grin = ${grinJson};
                          payload.obj.tiktok = ${tikTokJson};
                        } catch(err) {
                          console.log("Social media data did not save");
                        }

                        if (payload.obj.type == 'page' || payload.obj.type == 'track') {
                          payload.obj.ga4SessionId = '${ga4SessionData?.sessionId}'
                          payload.obj.ga4SessionNumber = '${ga4SessionData?.sessionNumber}'
                          payload.obj.ga4ClientId = '${ga4SessionData?.clientId}'
                          if('${ga4SessionData?.contentGroup}' != 'undefined') payload.obj.ga4ContentGroup = '${ga4SessionData?.contentGroup}'
                        }

                        if (payload.obj.type == 'page') {
                            let cookieArr = document.cookie.split(';')
                            let parsedCookie = cookieArr.filter((cookie) => cookie.includes('SessionGuid'))[0]
                            if (parsedCookie) {
                                payload.obj.sessionGuid = parsedCookie.split('=')[1];
                                return next(payload)
                            }

                        }

                        if (payload.obj.event !== 'Order Completed') {
                            return next(payload)
                        }
                        payload.obj.messageId = 'order-completed-' + payload.obj.properties.order_id;
                        payload.obj.orderId = payload.obj.properties.order_id;
                        next(payload);
                    }
                    analytics.reset();
                    analytics.setAnonymousId('${userContext.userGuid}');
                    analytics.addSourceMiddleware(segmentOrderSourceMiddleware);
                    analytics.load('${segmentApiKey}', {
                        integrations: {
                          "Segment.io": {
                            deliveryStrategy: {
                              strategy: "batching",
                              config: {
                                size: 10,
                                timeout: 5000
                              }
                            }
                          }
                        }
                      });
                }
            }();   
        window.dispatchEvent(new CustomEvent('segmentLoaded', null))          
    }  
`;
  // if we're rendering Segment, we have a userContext
  return (
    <Script
      id="segment-init"
      data-testid="segment-init"
      strategy="afterInteractive"
    >
      {segmentScript}
    </Script>
  );
}
